function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSoundOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  style: {
    fill: "#333"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.612 7.946a.95.95 0 0 0-.945-.011l-4.668 2.594H7a2.502 2.502 0 0 0-2.5 2.5v3.942c0 1.379 1.122 2.5 2.5 2.5h5l4.668 2.595a.96.96 0 0 0 .463.12.955.955 0 0 0 .95-.952V8.766a.943.943 0 0 0-.468-.82ZM5.5 16.971v-3.942c0-.827.673-1.5 1.5-1.5h4.629v6.942h-4.63c-.826 0-1.5-.673-1.5-1.5Zm7.129 1.706v-7.358l4.451-2.553.073 12.425-4.524-2.514Zm12.407-1.857a.5.5 0 1 1-.707.707l-1.82-1.82-1.82 1.82a.498.498 0 0 1-.708 0 .5.5 0 0 1 0-.707l1.82-1.82-1.82-1.82a.5.5 0 1 1 .707-.707l1.82 1.82 1.821-1.82a.5.5 0 1 1 .707.707L23.216 15l1.82 1.82Z",
  style: {
    fill: "#fff"
  }
}));
export default SvgIconSoundOff;